
import React from 'react';
import { useLoggedInUser } from '../../../resources/user/authService';
import SharedAdminLayout from 'shared-resources/components/src/AdminLayout';

const AdminLayout = (props) => {
  // Layout needs loggedInUser to be passed in
  const loggedInUser = useLoggedInUser();
  return (
    <SharedAdminLayout
      {...props}
      loggedInUser={loggedInUser}
    />
  );
}



AdminLayout.propTypes = SharedAdminLayout.propTypes;
AdminLayout.Skeleton = SharedAdminLayout.Skeleton;

export default AdminLayout;
